import * as React from 'react'
import type { FunctionComponent } from 'react'
import FormSection, { FormSectionRow } from '../../../molecules/FormSection/FormSection'
import { InputAttrs } from '../../../types'
import SingleLineInput from '../../../atoms/SingleLineInput/SingleLineInput'
import { Row } from './CompanyContact.styles'
import RadioGroup from '../../../molecules/RadioGroup/RadioGroup'
import FormInput from '../../../molecules/FormInput/FormInput'

export enum ApplyViaType {
  Email = 'Via e-mail',
  Website = 'Via mijn website',
  EasyApply = 'Via Easy Apply'
}

export const applyViaOptions = Object.values(ApplyViaType)

export type CompanyContactProps = {
  firstName: InputAttrs<string>,
  lastName: InputAttrs<string>,
  email: InputAttrs<string>,
  website: InputAttrs<string>,
  applyVia: InputAttrs<ApplyViaType>,
  includeEasyApply?: boolean,
}

type RenderApplyViaType = {
  viaValue: ApplyViaType
  email: InputAttrs<string>
  firstName: InputAttrs<string>
  lastName: InputAttrs<string>
  website: InputAttrs<string>
}

const RenderApplyVia = ({
  viaValue,
  email,
  firstName,
  lastName,
  website,
 }: RenderApplyViaType) => {
  switch (viaValue) {
    case ApplyViaType.Email:
      return (
        <>
          <FormSectionRow>
            <Row>
              <FormInput title="Voornaam" inputId="first-name-input" isValid={firstName.isValid} validationMessage={firstName.validationMessage}>
                <SingleLineInput
                  placeholder="Voornaam"
                  id="first-name-input"
                  {...firstName}
                />
              </FormInput>
              <FormInput title="Achternaam" inputId="last-name-input" isValid={lastName.isValid} validationMessage={lastName.validationMessage}>
                <SingleLineInput
                  placeholder="Achternaam"
                  id="last-name-input"
                  {...lastName}
                />
              </FormInput>
            </Row>
          </FormSectionRow>
          <FormInput title="E-mailadres" inputId="e-mail-input" isValid={email.isValid} validationMessage={email.validationMessage}>
            <SingleLineInput
              placeholder="E-mailadres"
              id="e-mail-input"
              {...email}
            />
          </FormInput>
        </>
      )
    case ApplyViaType.Website:
      return (
        <FormInput title="Website URL" inputId="website-input" isValid={website.isValid} validationMessage={website.validationMessage}>
          <SingleLineInput
            placeholder="Website URL"
            id="website-input"
            autoCorrect="off"
            {...website}
          />
        </FormInput>
      )
  }

  // Assuming ApplyViaType.EasyApply
  return null
};

const CompanyContact: FunctionComponent<CompanyContactProps> = ({
  applyVia,
  includeEasyApply = true,
  email,
  firstName,
  lastName,
  website,
  ...props
}) => {
  return (
  <FormSection title="Hoe wil je sollicitaties ontvangen?">
    <FormSectionRow>
      <RadioGroup
        {...applyVia}
        options={includeEasyApply ? applyViaOptions : applyViaOptions.filter(type => type !== ApplyViaType.EasyApply)}
      />
    </FormSectionRow>
    <RenderApplyVia {...props} email={email} firstName={firstName} lastName={lastName} website={website} viaValue={applyVia.value as ApplyViaType} />
  </FormSection>
)}

export default CompanyContact
